export interface EmploymentExpensesModel {
  voe?: Voe;
}

export enum VoeType {
  ByteCascade = 1,
  TruvDirect = 2,
}

export const VoeVendorName: { [key: number]: string } = {
  [VoeType.ByteCascade]: 'VOE Cascade',
  [VoeType.TruvDirect]: 'Truv',
};

export interface Voe {
  voeType?: VoeType;
  voeCascadeNewOrdersAllowed?: boolean;
  voeCascadeStandaloneEnabled?: boolean;
}
